import { render, staticRenderFns } from "./AddBase.vue?vue&type=template&id=8962345e&"
import script from "./AddBase.vue?vue&type=script&lang=ts&"
export * from "./AddBase.vue?vue&type=script&lang=ts&"
import style0 from "./AddBase.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports